<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1"><span style="color: #2AD3DA">{{ data1['price'] + '万吨'}}</span></div>
        <div class="data2"><span style="color: #2AD3DA">{{ data2['price'] }}</span></div>
        <div class="data3"><span style="color: #2AD3DA">{{ data3['price'] }}</span></div>
        <div class="data4"><span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5"><span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6"><span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7"><span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8"><span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="data9"><span style="color: #2AD3DA">{{ data9['price'] }}</span>
        </div>
        <div class="data10"><span style="color: #2AD3DA">{{ data10['price'] }}</span>
        </div>
        <div class="data11"><span style="color: #2AD3DA">{{ data11['price'] }}</span>
        </div>
        <div class="data12"><span style="color: #2AD3DA">{{ data12['price'] }}</span>
        </div>
        <div class="data13"><span style="color: #2AD3DA">{{ data13['price'] }}</span>
        </div>
        <div class="data14"><span style="color: #2AD3DA">{{ data14['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
        <div class="differPrice7 redColor" v-if="chainPrice['differPrice7'] > 0">
          {{ '+' + chainPrice['differPrice7'] }}
        </div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write" @mouseover="changeFlag(40)" @click="toTwoPage('/adipic/twoPage/industry', 40)"
               :class="{'title-write-red' : industryFlag===40}">早间提示
          </div>
          <div class="title-write" @mouseover="changeFlag(44)" @click="toTwoPage('/adipic/twoPage/industry', 44)"
               :class="{'title-write-red' : industryFlag===44}">市场动态
          </div>
          <span class="title-more fr" @click="toTwoPage('/adipic/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 40">
          <ul>
            <li v-for="(item, index) in industryListOne" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/adipic/industry', item.id, 40)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 44">
          <ul>
            <li v-for="(item, index) in industryListTwo" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/adipic/industry', item.id, 44)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position:relative;">
          <img style="margin-bottom: -7px;" src="../../assets/ironstone/jiage.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #222222;line-height: 33px;">
            价格</p>
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer"
                @click="toTwoPage('/adipic/twoPage/price', 'issue_adipicAcid_east_price')"> >></span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 1"
                @click="toTwoPage('/adipic/twoPage/price', 'issue_adipicAcid_east_price')"
                :class="{'priceFlag':priceFlag === 1}">华东价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 2"
                @click="toTwoPage('/adipic/twoPage/price', '50')"
                :class="{'priceFlag':priceFlag === 2}">进出口价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 3"
                @click="toTwoPage('/adipic/twoPage/price', '51')"
                :class="{'priceFlag':priceFlag === 3}">挂结牌价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 4"
                @click="toTwoPage('/adipic/twoPage/price', '52')"
                :class="{'priceFlag':priceFlag === 4}">下游产品价格</span>
          <div class="classification-content" v-if="priceFlag === 1">
            <div class="classification-content-div price" v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/adipic/price', item.completeOriginalDate, 'issue_adipicAcid_east_price')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.date + '己二酸华东价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 2">
            <div class="classification-content-div price" v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/adipic/backPrice', item.id, '50')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 3">
            <div class="classification-content-div price" v-for="(item, index) in priceThreeList" :key="index"
                 @click="goDetail('/adipic/backPrice', item.id, '51')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 4">
            <div class="classification-content-div price" v-for="(item, index) in priceFourList" :key="index"
                 @click="goDetail('/adipic/backPrice', item.id, '52')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/home/jineixiananchanliang.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #fff;line-height: 33px;">
            产量</p>
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer;color:#fff"
                @click="toTwoPage('/adipic/twoPage/yield')"> >></span>
          <img src="../../assets/home/neibu.png" style="position: absolute;left: 83px;width: 70px;top: 24px;" alt="">
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/adipic/yield', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '己二酸全国产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <span class="fr" @click="toTwoPage('/adipic/twoPage/report')"> >></span>
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/adipic/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/adipic/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/adipic/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'库存'" :flag="false" :unit="false" :neibu="true"
                                :url="'/adipic/twoPage/stock'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in stockList" :key="index"
                 @click="goDetail('/adipic/stock', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '己二酸全国库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'企业动态'" :flag="false" :unit="false"
                                :url="'/adipic/twoPage/dynamic'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in dynamicList" :key="index"
                 @click="goDetail('/adipic/dynamic', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/adipic/map')" alt="">
<!--            <Expect :marginTop="'40px'"></Expect>-->
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游动态'" :flag="false" :unit="false"
                                :params="{title:'下游动态',typeList:['聚酯多元醇', 'TPU', 'PU浆料', '鞋底原液']}"
                                :url="'/adipic/twoPage/downstream'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="downstreamFlag = 88"
                @click="toTwoPage('/adipic/twoPage/downstream', 88)"
                :class="{'stockFlag':downstreamFlag === 88}">聚酯多元醇</span>
          <span class="classification-tabs-three" @mouseover="downstreamFlag = 89"
                @click="toTwoPage('/adipic/twoPage/downstream', 89)"
                :class="{'stockFlag':downstreamFlag === 89}">TPU</span>
          <span class="classification-tabs-three" @mouseover="downstreamFlag = 90"
                @click="toTwoPage('/adipic/twoPage/downstream', 90)"
                :class="{'stockFlag':downstreamFlag === 90}">PU浆料</span>
          <span class="classification-tabs-three" @mouseover="downstreamFlag = 91"
                @click="toTwoPage('/adipic/twoPage/downstream', 91)"
                :class="{'stockFlag':downstreamFlag === 91}">鞋底原液</span>
          <div class="classification-content" style="margin-top: 4px" v-if="downstreamFlag === 88">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in downstreamOneList" :key="index"
                 @click="goDetail('/adipic/downstream', item.id, 88)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="downstreamFlag === 89">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in downstreamTwoList" :key="index"
                 @click="goDetail('/adipic/downstream', item.id, 89)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="downstreamFlag === 90">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in downstreamThreeList" :key="index"
                 @click="goDetail('/adipic/downstream', item.id, 90)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="downstreamFlag === 91">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;" v-for="(item, index) in downstreamFourList" :key="index"
                 @click="goDetail('/adipic/downstream', item.id, 91)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative;">
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/adipic/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="exitClass">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="industrialFlag">
      <AdipicIndustrial :chainPrice="chainPrice" :chainTitle="chainTitle" :data1="data1" :data2="data2"
                            :data3="data3"
                            :data4="data4" :data5="data5" :data6="data6" :data7="data7" :data8="data8" :data9="data9"
                            :data10="data10" :data11="data11" :data12="data12" :data13="data13" :data14="data14"
                            @closeIndustrialCh="closeIndustrial"></AdipicIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  industryDetail,
  reportNoAuthList,
  reportDetail,
  standardDetail,
  queryPageList,
  priceNoAuthList,
  chainList
} from '@/api/adipic'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import AdipicIndustrial from '@/components/bigChart/adipicIndustrial'

export default {
  name: "index",
  components: {
    ClassificationHeader,
    Expect,
    AdipicIndustrial,
  },
  data() {
    return {
      // 行业动态
      industryFlag:40,
      industryListOne: [],
      industryListTwo: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 1,
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      priceFourList:[],
      // 库存
      stockList: [],
      // 企业动态
      dynamicList:[],
      // 下游动态
      downstreamFlag: 88,
      downstreamOneList: [],
      downstreamTwoList: [],
      downstreamThreeList:[],
      downstreamFourList:[],
      // 产量
      yieldList: [],
      // 行业标准
      standardList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      data9: {},
      data10: {},
      data11: {},
      data12: {},
      data13: {},
      data14: {},
      chainPrice: {},
      // 重点企业资讯
      enterpriseList: [],
      industrialFlag: false,
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // // 产业链
      chainList({dictDataType: 'issue_caprolactam_chain'}).then(res => {
        this.chainTitle = res.data['titleTime'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.data9 = res.data['data9'];
        this.data10 = res.data['data10'];
        this.data11 = res.data['data11'];
        this.data12 = res.data['data12'];
        this.data13 = res.data['data13'];
        this.data14 = res.data['data14'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 40}).then(res => {
        this.industryListOne = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 44}).then(res => {
        this.industryListTwo = res.rows;
      })
      // 研究报告
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 技术及标准
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 9, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
      // 企业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 45}).then(res => {
        this.dynamicList = res.rows;
      })
      // 下游动态
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 88}).then(res => {
        this.downstreamOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 89}).then(res => {
        this.downstreamTwoList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 90}).then(res => {
        this.downstreamThreeList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 91}).then(res => {
        this.downstreamFourList = res.rows;
      })
      // 价格
      priceNoAuthList({
        pageNum: 1,
        pageSize: 6,
        dictDataType: 'issue_adipicAcid_east_price',
        dataType:1,
      }).then(res => {
        this.priceOneList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 50,
      }).then(res => {
        this.priceTwoList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 51,
      }).then(res => {
        this.priceThreeList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 52,
      }).then(res => {
        this.priceFourList = res.rows;
      })
      // 库存
      queryPageList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: 'issue_adipicAcid_input_stock'
      }).then(res => {
        this.stockList = res.rows;
      })
      // 产量
      queryPageList({pageNum: 1, pageSize: 6, dictDataType: 'issue_adipicAcid_input_yield'}).then(res => {
        this.yieldList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['己二酸', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['己二酸', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag) {
      this.$router.push({path: `${url}`, query: {id, flag}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/home/jineixiananchanyelian.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #CEEFF6;
      top: 21px;
      left: 406px;
    }

    .data1 {
      font-size: 12px;
      position: absolute;
      top: 161px;
      left: 28px;
      width: 97px;
      height: 50px;
      text-align: center;
    }

    .data2 {
      font-size: 12px;
      position: absolute;
      top: 207px;
      left: 28px;
      width: 97px;
      height: 50px;
      text-align: center;
    }

    .data3 {
      font-size: 12px;
      position: absolute;
      top: 249px;
      left: 28px;
      text-align: center;
      width: 106px;
      height: 50px;
    }

    .data4 {
      font-size: 12px;
      position: absolute;
      top: 291px;
      left: 28px;
      width: 106px;
      text-align: center;
      height: 50px;
    }

    .data5 {
      font-size: 12px;
      position: absolute;
      top: 214px;
      left: 139px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 170px;
      left: 261px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 282px;
      left: 261px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 120px;
      left: 400px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data9 {
      font-size: 10px;
      position: absolute;
      top: 185px;
      left: 400px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data10 {
      font-size: 10px;
      position: absolute;
      top: 229px;
      left: 400px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data11 {
      font-size: 10px;
      position: absolute;
      top: 276px;
      left: 400px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data12 {
      font-size: 10px;
      position: absolute;
      top: 63px;
      left: 539px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data13 {
      font-size: 10px;
      position: absolute;
      top: 108px;
      left: 539px;
      width: 106px;
      height: 50px;
      text-align: center;
    }
    .data14 {
      font-size: 10px;
      position: absolute;
      top: 151px;
      left: 539px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .differPrice1 {
      position: absolute;
      top: 64px;
      left: 184px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 331px;
      left: 184px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 85px;
      left: 368px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 154px;
      left: 368px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 205px;
      left: 368px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      position: absolute;
      top: 251px;
      left: 368px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
        cursor: pointer;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 93px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}

.head {
  color: #222222;
  height: 35px;
  line-height: 30px;
  position: relative;
  border-bottom: 2px solid #ccc;

  i {
    width: 60px;
    height: 2px;
    background: #CCCCCC;
    display: inline-block;
    position: absolute;
    bottom: 0;
  }

  em {
    width: 4px;
    height: 18px;
    background: #D3131A;
    font-style: normal;
    display: inline-block;
    margin-right: 9px;
    vertical-align: middle;
  }

  p {
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
  }

  .unit {
    color: #999999;
    margin-left: 10px;
    display: inline-block;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    cursor: pointer;
    height: 20px;
    border-bottom: 1px solid #fff;
  }

  span:hover {
    border-bottom: 1px solid #222;
  }
}
</style>
